(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-slider"] && !window.DesignMode) return;
  try {
    
  class ArticleSlider extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        $slider: this.querySelector('.article_slider-slider'),
        $sliderDots: null,
      };
      this.$slider = null;
    }

    connectedCallback() {
      this.$slider = $(this.elements.$slider).slick({
        dots: false,
        slidesToShow: parseFloat(this.dataset.slidesToShow),
        dots: true,
        arrows: true,
        infinite: false,
        nextArrow:
          '<span class="slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.33,
            },
          },
        ],
      });

      this.$slider.css('opacity', '1');
      this.elements.$sliderDots = this.querySelector('.slick-dots');
      this.elements.$sliderDots.querySelectorAll('li').forEach((el, i) => {
        el.insertAdjacentHTML(
          'afterend',
          `<li class="${i == 0 ? 'slick-active' : ''}" data-index="${i}" ><button type="button">${i}</button></li>`
        );
        el.remove();
      });
      this.elements.$sliderDots.querySelectorAll('li').forEach((el) => {
        el.addEventListener('click', (e) => {
          this.$slider.slick('slickGoTo', parseInt(e.currentTarget.dataset.index));
        });
      });
    }
  }

  if (customElements.get('article-slider') === undefined) {
    customElements.define('article-slider', ArticleSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-video-banner"] && !window.DesignMode) return;
  try {
    
  class CustomImageVideoBanner extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        videoControls: this.querySelector('.civb-video-controls'),
        video: this.querySelector('.civb-video video'),
        mobileVideo: this.querySelector('.civb-mobile-video video'),
        muteButton: this.querySelector('[data-video-mute-button'),
        playButton: this.querySelectorAll('[data-video-play-button]'),
        pauseButton: this.querySelector('[data-video-pause-button]'),
        videoImage: this.querySelector('.video-pause-image-desktop'),
        mobileVideoImage: this.querySelector('.video-pause-image-mobile'),
      };
    }

    connectedCallback() {
      this.elements.playButton.forEach((el) => el.addEventListener('click', this.toggleVideoPlay.bind(this)));
      this.elements.pauseButton?.addEventListener('click', this.toggleVideoPlay.bind(this));
      this.elements.muteButton?.addEventListener('click', this.toggleVideoMute.bind(this));
      this.elements.video?.addEventListener('ended', this.onVideoEnded.bind(this));
      this.elements.mobileVideo?.addEventListener('ended', this.onVideoEnded.bind(this));
    }

    toggleVideoMute(event) {
      const button = event.currentTarget;
      const video = this.getVideo();
      video.muted ? (video.muted = false) : (video.muted = true);
      button.classList.toggle('is-muted');
    }

    toggleVideoPlay() {
      const video = this.getVideo();
      const videoControls = this.elements.videoControls;

      video.paused ? video.play() : video.pause();
      videoControls.classList.toggle('is-playing');
      this.classList.toggle('is-playing');
    }

    onVideoEnded() {
      this.resetControls();
    }

    resetControls() {
      this.classList.remove('is-playing');
      const elements = this.querySelectorAll('.is-playing');
      elements.forEach((el) => el.classList.remove('is-playing'));
    }

    getVideo() {
      return this.checkDeviceType() === 'mobile' ? this.elements.mobileVideo : this.elements.video;
    }

    checkDeviceType() {
      return window.innerWidth <= 768 ? 'mobile' : 'desktop';
    }
  }

  if (customElements.get('custom-image-video-banner') === undefined) {
    customElements.define('custom-image-video-banner', CustomImageVideoBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          this.onChildElementsLoad();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    onChildElementsLoad() {
      this.runSlick();
    }

    runSlick() {
      const recommendationsId = this.querySelector('.cstmgrid').id;

      const $recommSlider = $(`#${recommendationsId}`).slick({
        infinite: false,
        slidesToShow: 3.38,
        dots: false,
        accessibility: true,
        arrows: true,
        nextArrow:
          '<span class="slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      });

      $(`#${recommendationsId}`).css('opacity', '1');
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.elements = {
        slider: this.querySelector('.featured-collection__slider'),
      };
      this.settings = {
        enableArrows: Boolean(this.dataset.enableArrows),
        enablePagination: Boolean(this.dataset.enablePagination),
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = $(this.elements.slider).slick({
        dots: true,
        infinite: false,
        slidesToShow: 1.25,
        nextArrow:
          '<span class="custom-slick-arrows slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="custom-slick-arrows slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  }

  if (window.customElements.get('featured-collection') === undefined) {
    window.customElements.define('featured-collection', FeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fifty-fifty-images"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.fifty-fifty-images__lower').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      arrows: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick',
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function mobileToggler(x) {
    if (x.matches) {
      document.querySelectorAll('.mobile-toggler').forEach(item => item.addEventListener('click', (event) => {
        event.preventDefault();
        let toggler = event.currentTarget.classList;
        toggler.contains('toggled') ? toggler.remove('toggled') : toggler.add('toggled');
      }));
    }
  }
  var x = window.matchMedia("(max-width: 991px)")
  mobileToggler(x);
  x.addListener(mobileToggler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const mega_menu_overlay = document.querySelector('#mega-menu-overlay');
  const elements = document.querySelectorAll('header-menu');

  elements.forEach((element) => {
    element.addEventListener('mouseover', handleMouseOver);
    element.addEventListener('mouseout', handleMouseOut);
  });

  function handleMouseOver(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.setAttribute('open', '');
    mega_menu_overlay.style.display = 'block';
  }
  function handleMouseOut(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.removeAttribute('open', '');
    mega_menu_overlay.style.display = 'none';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-store-dealer-form"] && !window.DesignMode) return;
  try {
    
  const elements = {
    form: document.querySelector('[data-store-dealer-form]'),
    submitButton: document.querySelector('[data-store-dealer-submit]'),
    alerts: document.querySelectorAll('[data-store-dealer-alert]'),
    alertsClose: document.querySelectorAll('[data-alert-close]'),
  };

  function onFormSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    elements.submitButton.disabled = true;

    fetch(elements.form.getAttribute('action'), {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        handleAlerts('success');
      })
      .catch((error) => {
        handleAlerts('error');
        console.error(error);
      })
      .finally(() => {
        resetForm();
        elements.submitButton.disabled = false;
      });
  }

  function setUpCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('DealerCountry', 'DealerProvince', {
        hideElement: 'DealerProvinceContainer',
      });
    }
  }

  function resetForm() {
    const inputs = elements.form.querySelectorAll('input');
    const selects = elements.form.querySelectorAll('select');

    inputs.forEach((el) => {
      el.value = '';
    });

    selects.forEach((el) => {
      el.selectedIndex = 0;
    });
  }

  function handleAlerts(status) {
    elements.alerts.forEach((el) =>
      el.dataset.status === status ? (el.style.display = 'block') : (el.style.display = 'none')
    );
  }

  function onLoad(params) {
    setUpCountries();

    // Bind Listeners
    elements.form.addEventListener('submit', onFormSubmit);
    elements.alertsClose.forEach((el) => {
      el.addEventListener('click', () => {
        handleAlerts('hidden');
      });
    });
  }

  onLoad();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoga-classes-facets"]) return;
  try {
    
  (() => {    
    const section = document.getElementById('yoga-classes-facets');
    const toggleBtn = section.querySelectorAll('[data-js-toggle-button]');

    toggleBtn.forEach(btn => {
      btn.addEventListener('click', toggleDropdown);
    });

    function toggleDropdown(event) {
      const el = event.currentTarget;
      const parent = el.closest('[data-js-facet]');
      const dropdown = parent.querySelector('[data-js-dropdown]');

      dropdown.classList.toggle('is-collapsed');
      el.classList.toggle('is-active');
    }
    
  })()  

  } catch(e) { console.error(e); }
})();
})();
